import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

import 'App.css';
import CsvButton from 'Common/Buttons/CsvButton';
import ActionButton from 'Common/Buttons/ActionButton';
import Pagination from 'Common/Pagnination/Pagination';
import Page from 'Common/Layout/Page';
import TeamsColumns, { keyField } from './TeamsColumns';
import Refiner from 'Common/Components/Refiner/Refiner.container';
import Section from 'Common/Layout/Section';
import { debounce, addKeyField } from 'utils';
import { getTeams } from '../../../Views/PostEx6/service';
import { withClsCompTracking } from 'Telemetry/telemetry.service';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';
import { UPDATE_REFINER_SELECTORS } from '../../../../../../Redux/Enums/Contracts.Globals.Enums';
import { connect } from 'react-redux';
import { apptTypesSelect } from 'Redux/Selectors/Contracts.Globals.Selectors';

const { SearchBar, ClearSearchButton } = Search;

class TeamsTable extends Component {
	constructor(props) {
		super(props);

		const refinerFields = [
			{ name: 'type', label: "Appt Type", type: 'select', dataSource: props.apptTypes },
			{ name: 'markingMethod', label: 'Marking Method', type: 'text' },
			{ name: 'title', label: 'Team Name contains', type: 'text' },
			{ name: 'markingTeamCode', label: 'Marking Team Code', type: 'text' }
		];		

		this.state = {
			allTeams: [],
			pageNo: 1,
			pageSize: 10,
			total: 0,
			isLoading: true,
			team: null,
            updateYear: PropTypes.func.isRequired,
			refinerOpen: true,
			refinerFields: refinerFields,
			selectors: []
		};
		this.componentRef = React.createRef();
		this.searchComponentRef = React.createRef();
		this.columns = TeamsColumns();
		this.updateYear = this.updateYear.bind(this);
		this.filter = filterFactory();
		this.onTableChange = debounce(this.onTableChange, 400);
	}

	async componentDidUpdate(prevProps) {
		if (this.props.searchYear !== prevProps.searchYear) {
		
			const { pageNo, pageSize } = this.state;
			const query = {
				sortOrder: 'asc',
				sortField: 'title',
				page: pageNo,
				sizePerPage: pageSize,
				searchText: '',
				flagExportData: false
			};

			await this.getData(query);
		}
	}

	async componentDidMount() {
		const { pageNo, pageSize } = this.state;
		const query = {
			sortOrder: 'asc',
			sortField: 'title',
			page: pageNo,
			sizePerPage: pageSize,
			searchText: '',
			flagExportData: false
		};

		await this.getData(query, this.props.persistedSelectors.selectors);
	}

	getData = async (query, selectors) => {
		const { apptTypes, handleErrors, searchYear } = this.props;
		const { flagExportData: isExport } = query;

		try {
			await this.setState({ isLoading: true });
	
			let {
				status,
				data: {
					data: { total, teams },
					errors
				}
			} = await getTeams(searchYear, apptTypes, query, selectors);
		
			if (status === 200) {
				teams = isExport ? teams : addKeyField(teams, 'markingTeamId', 'type', 'id_type');
				this.setState({ total, allTeams: teams });
			}
			handleErrors(['Error fetching Teams data', ...errors]);
			
			this.setState({ total: total ?? null, allTeams: teams ?? [] });
		}
		finally
		{
			await this.setState({ isLoading: false });
		}
    };

    onRefinerToggle = async () => {
        const { refinerOpen } = this.state;
        this.setState({ refinerOpen: !refinerOpen });
    };

	onTableChange = async (type, state) => {
		let { sortOrder, sortField, page, sizePerPage, searchText } = state;
		sortOrder = sortOrder ? sortOrder : 'asc';
		sortField = sortField ? sortField : 'title';
		page = type === 'search' ? 1 : page;
		const query = { sortOrder, sortField, page, sizePerPage, searchText, flagExportData: false };
		await this.getData(query);
		this.setState({ pageNo: page, pageSize: sizePerPage });
		this.componentRef.scrollIntoView({ behavior: 'smooth' });
	};

	exportData = async props => {
		const query = {
			sortOrder: 'asc',
			sortField: 'title',
			page: 0,
			sizePerPage: 0,
			searchText: '',
			flagExportData: true
		};
		const { teams } = await this.getData(query);
		props.onExport(teams);
	};

	onTeamClick = (row, isSelect) => {
		if (isSelect) {
			const { type, title, markingTeamCode, markingTeamId } = row;
			const team = {
				apptType: type,
				teamTitle: title,
				teamCode: markingTeamCode,
				teamId: markingTeamId,
				year: Number(this.props.searchYear)
			};
			this.setState({ team },
				() => this.onAppointeesClick()
			);
		}
	};

	onAppointeesClick = () => {
		const { team } = this.state;
		const { setTeam } = this.props;

		if (team) {
			setTeam(team);
		}
	};

	updateYear = async year => {
		const { selectedOption } = this.state;       
        const sizePerPage = this.state.pageSize;

        if (selectedOption === 'active') {
            activeStatus = true;
        }

        let query = {
            sortOrder: 'asc',
            sortField: 'title',
            page: 0,
            sizePerPage,
            searchText: '',
            flagExportData: false
        };

        await this.setState({ searchYear: year });
        await this.getData(query);
    };

	onRefinementSelectorsChange = async(selectors) => {
		const { refinerFields, isLoading, pageSize } = this.state;

		if (!isLoading)
		{
			// TODO [TL]: Figure out how to encapsulate this in the Refiner itself.
			// Stores the Refiner selector state within Redux for re-population later.
			this.props.updateRefinerSelectors(selectors, refinerFields);
			let query = {
				sortOrder: 'asc',
				sortField: 'title',
				page: 0,
				sizePerPage: pageSize,
				searchText: '',
				flagExportData: false
			};

			await this.getData(query, selectors);
		}
    }

	render() {
		const { allTeams, pageNo, pageSize, total, isLoading, team, refinerOpen, refinerFields } = this.state;
		const disableButton = team === null;
		const { className = '', apptTypes } = this.props;
		const { exportData, columns, onTableChange, filter, onTeamClick, onAppointeesClick, onRefinerToggle, onRefinementSelectorsChange } = this;
		const handleUpdateYear = this.updateYear;
		const selectRow = {
			mode: 'radio',
			clickToSelect: true,
			hideSelectColumn: true,
			classes: 'selected-row',
			onSelect: onTeamClick
		};
		return (
			<Page title="Contract Release Post EX6">
				<Section>
					<div ref={el => (this.componentRef = el)} className={className}>
					<PaginationProvider
						pagination={paginationFactory({
							custom: true,
							totalSize: total,
							page: pageNo,
							sizePerPage: pageSize,
							showTotal: true,
							withFirstAndLast: true,
							alwaysShowAllBtns: true,

						})}
						keyField={keyField}
						columns={columns}
						data={allTeams}
					>
						{({ paginationProps, paginationTableProps }) => (
							<ToolkitProvider
								keyField={keyField}
								columns={columns}
								data={allTeams}
								search={{ placeholder: 'Search...' }}
								exportCSV={{
									fileName: `post_Ex6_Teams_${apptTypes.join('_')}.csv`,
									separator: ','
								}}
							>
								{toolkitProps => {
									const { searchText } = toolkitProps.searchProps;
									return (
										<div className="container-fluid">
											<div className="paginator">
												<div>
													<YearSelector numberOfPreviousYears={1} numberOfFutureYears={1} year={this.props.searchYear} grouping={this.state.grouping} updateYear={handleUpdateYear} addLoopCheck={true} />
												</div>
												<div>
													<SearchBar ref={el => (this.searchComponentRef = el)} {...toolkitProps.searchProps} />
													{searchText && <ClearSearchButton {...toolkitProps.searchProps} className="clear-search" />}
												</div>
											</div>
											<Section>
												<Refiner
													disabled={false}
													fields={refinerFields}
													open={refinerOpen}
													data={allTeams}
													onPanelToggleClick={onRefinerToggle}
													onRefinementSelectorsChange={onRefinementSelectorsChange}
												/>
											</Section>
											<BootstrapTable
												classes={'table table-primary table-striped table-sm table-responsive-md'}
												{...toolkitProps.baseProps}
												{...paginationTableProps}
												remote={{ sort: true, pagination: true, search: true }}
												onTableChange={onTableChange}
												filter={filter}
												bootstrap4
												striped
												condensed
												hover
												size="sm"
												loading={isLoading}
												noDataIndication={() => <p>No data Available</p>}
												selectRow={selectRow}
											/>
											<div className="paginator">
												<CsvButton onClick={exportData} {...toolkitProps.csvProps} />
												<Pagination total={total} paginationProps={paginationProps} />												
											</div>
										</div>
									);
								}}
							</ToolkitProvider>
						)}
					</PaginationProvider>

				</div>
				</Section>
			</Page>
		);
	}
}

TeamsTable.propTypes = {
	setTeam: PropTypes.func.isRequired,
	qualYear: PropTypes.number.isRequired,
	apptTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
	handleErrors: PropTypes.func.isRequired
};

const mapStateToProps = state => {
	return {
		searchYear: state.contract_globals.qualification_year.active,
		persistedSelectors: state.contract_globals.refiner,
		refinedTypes: apptTypesSelect	
	};
};

const mapDispatchToProps = dispatch => {
	return {
		updateRefinerSelectors: async (selectors, refinerFields) => await dispatch({ type: UPDATE_REFINER_SELECTORS, payload: {selectors, refinerFields}})
	};
};

export default withClsCompTracking('Post Ex6 Teams Table')(connect(mapStateToProps, mapDispatchToProps)(TeamsTable));